import { useAuth } from '@/lib'
import { AnimatePresence, motion } from 'motion/react'
import type { ReactNode } from 'react'
import { AuthPromotionalPanel } from './auth-promotional-panel'

interface AuthLayoutProps {
	children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
	const { isLoading } = useAuth()

	return (
		<AnimatePresence mode="wait">
			{!isLoading
				? (
					<div className="h-screen flex overflow-hidden">
						{/* Left side - Form */}
						<div className="flex-1 flex justify-center bg-white px-4 overflow-y-auto">
							<motion.div
								initial={{ opacity: 0, y: 15, filter: 'blur(5px)' }}
								animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
								exit={{ opacity: 0, y: -15, filter: 'blur(5px)' }}
								transition={{
									default: { type: 'spring', duration: 0.6, bounce: 0.2 },
									filter: { duration: 0.5, ease: 'easeOut' },
								}}
								className="w-full max-w-lg my-auto"
							>
								{children}
							</motion.div>
						</div>

						{/* Right side - Promotional panel */}
						<div className="hidden lg:flex lg:flex-1">
							<AuthPromotionalPanel />
						</div>
					</div>
				)
				: null}
		</AnimatePresence>
	)
}
